import api from './api';

export const getShiftRotations = (params) => api.get('/v1/shift-rotations', { params });
export const getShiftRotation = (id) => api.get(`/v1/shift-rotations/${id}`);
export const createShiftRotation = (data) => api.post('/v1/shift-rotations', data);
export const updateShiftRotation = (id, data) => api.put(`/v1/shift-rotations/${id}`, data);
export const deleteShiftRotation = (id) => api.delete(`/v1/shift-rotations/${id}`);
export const batchDeleteShiftRotations = (ids) => api.post('/v1/shift-rotations/batch-delete', ids);
export const getShiftRotationUsers = (id) => api.get(`/v1/shift-rotations/${id}/users`);
export const assignShiftRotationUsers = (id, data) => api.post(`/v1/shift-rotations/${id}/assign`, data);
export const removeShiftRotationUser = (id, userId) => api.delete(`/v1/shift-rotations/${id}/users/${userId}`);
export const batchRemoveShiftRotationUsers = (id, userIds) => api.post(`/v1/shift-rotations/${id}/users/batch-remove`, userIds);
